import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "../../styles/CierresMensuales.css";

class CierresMensualesProduccion extends Component {
    render() {
        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91.5vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="CIERRES MENSUALES DE PRODUCCIÓN"
                    subtitulo=""
                    noBorder
                >
                    <Listado />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CierresMensualesProduccion);
